module.exports = __webpack_public_path__ + "img/saas_try.d7bdd251.jpg";